angular.module('unica_wiki.wiki_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// RELATOR
		.state('app.wiki', {
			url: '/wiki',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/wiki/templates/wiki.html',
					controller: 'WikiBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// RELATOR LIST AND DELETE
			.state('app.wiki.list', {
				url: '/list',
				views: {
					'wikiContent': {
						templateUrl: './modules/wiki/templates/list.html',
						controller: 'WikiListController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Wiki'
				}
			})

			// RELATOR CREATE
			.state('app.wiki.create', {
				url: '/create',
				views: {
					'wikiContent': {
						templateUrl: './modules/wiki/templates/create.html',
						controller: 'WikiCreateController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Aggiungi Dato',
					parent: 'app.wiki.list'
				}
			})

			// RELATOR EDIT
			.state('app.wiki.edit', {
				url: '/edit/:id',
				views: {
					'wikiContent': {
						templateUrl: './modules/wiki/templates/edit.html',
						controller: 'WikiEditController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Modifica Dato',
					parent: 'app.wiki.list'
				}
			})

			// RELATOR EDIT
			.state('app.wiki.detail', {
				url: '/detail/:id',
				views: {
					'wikiContent': {
						templateUrl: './modules/wiki/templates/detail.html',
						controller: 'WikiDetailController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Visualizza',
					parent: 'app.wiki.list'
				}
			});


});

